module.exports = __webpack_public_path__ + "img/35-4UC.95df5fe.jpg";